import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import homePlugin from '@backstage/plugin-home/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { keycloakAuthApi } from './keycloak';
import { CustomSignInPage } from './modules/auth/CustomSignInPage';
import { homeModule } from './modules/home';
import { navModule } from './modules/nav';
import approvalGateScaffolderModule from '@internal/scaffolder-module-approval-gate-frontend';
import customerRegistryScaffolderModule from '@internal/scaffolder-module-customer-registry-frontend';
import naptaPickerScaffolderModule from '@internal/scaffolder-module-napta-picker-frontend';
import customPickerScaffolderModule from '@internal/scaffolder-module-custom-picker-frontend';
import projectPickerScaffolderModule from '@internal/scaffolder-module-ekiprojects-frontend';
import { themeModule } from './modules/theme';
import { ScaffolderTranslations } from './modules/translations';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => CustomSignInPage,
  },
});

export default createApp({
  features: [
    catalogPlugin,
    homePlugin,
    scaffolderPlugin,
    homeModule,
    navModule,
    themeModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [keycloakAuthApi, signInPage, ScaffolderTranslations],
    }),
    approvalGateScaffolderModule,
    customerRegistryScaffolderModule,
    naptaPickerScaffolderModule,
    customPickerScaffolderModule,
    projectPickerScaffolderModule,
  ],
});
